import { TripViewModel } from '@wegoTypes/flights/tripViewModel';

import { DepartLegGroup } from './types';

export function groupTripViewModelsBasedOnDepartLeg(tripViewModels: TripViewModel[]) {
  return tripViewModels.reduce((acc, tripViewModel) => {
    const departLegKey = tripViewModel.legs[0].leg.id;

    const departLegGroup = acc.find(
      (departLegGroup) => departLegGroup.departLegId === departLegKey,
    );

    if (departLegGroup) {
      departLegGroup.tripViewModels.push(tripViewModel);
    } else {
      acc.push({
        departLegId: departLegKey,
        tripViewModels: [tripViewModel],
      });
    }

    return acc;
  }, [] as Array<DepartLegGroup>);
}
